import React from 'react'
import { isEmpty } from 'lodash'

import NoData from '@/components/NoData'
import { Drag, Drop, DragAndDrop } from '@/components/dragDrop'

export const CategoryEntryDisplay = ({
  categories,
  readOnly,
  onDragEnd,
  renderCategoryHeader,
  renderEntry,
  renderEmptyCategory,
  renderCategoryFooter,
  uncategorizedId,
  categoryDragType = 'droppable-category',
  entryDragType = 'droppable-entry',
}) => {
  if (isEmpty(categories.order)) {
    return (
      <div className="empty-table">
        <NoData text="Create a new category to begin" position="left" />
      </div>
    )
  }

  const uncategorized = uncategorizedId ? categories.entries[uncategorizedId] : null
  const draggableOrder = uncategorizedId
    ? categories.order.filter((categoryId) => categoryId !== uncategorizedId)
    : categories.order

  const renderCategory = (categoryId, index) => {
    const category = categories.entries[categoryId]
    const isUncategorized = uncategorizedId && categoryId === uncategorizedId

    return (
      <Drag
        key={categoryId}
        draggableId={categoryId}
        index={index}
        outer
        nestedEntriesCount={category.order.length}
        readOnly={readOnly}
      >
        <div className="playbook-category-container">
          {renderCategoryHeader(categoryId, category, isUncategorized)}
          <Drop droppableId={categoryId} type={entryDragType}>
            {isEmpty(category.order)
              ? renderEmptyCategory && renderEmptyCategory(categoryId, isUncategorized)
              : category.order.map((entryId, entryIndex) => {
                  return (
                    <Drag
                      key={entryId}
                      draggableId={entryId}
                      index={entryIndex}
                      readOnly={readOnly}
                    >
                      {renderEntry(category.entries[entryId], entryId, categoryId)}
                    </Drag>
                  )
                })}
          </Drop>
          {renderCategoryFooter && renderCategoryFooter(categoryId, isUncategorized)}
        </div>
      </Drag>
    )
  }

  return (
    <DragAndDrop onDragEnd={onDragEnd}>
      {uncategorized && (
        <div className="playbook-category-container uncategorized-category">
          {renderCategoryHeader(uncategorizedId, uncategorized, true)}
          <Drop droppableId={uncategorizedId} type={entryDragType}>
            {isEmpty(uncategorized.order)
              ? renderEmptyCategory && renderEmptyCategory(uncategorizedId, true)
              : uncategorized.order.map((entryId, entryIndex) => {
                  return (
                    <Drag
                      key={entryId}
                      draggableId={entryId}
                      index={entryIndex}
                      readOnly={readOnly}
                    >
                      {renderEntry(uncategorized.entries[entryId], entryId, uncategorizedId)}
                    </Drag>
                  )
                })}
          </Drop>
          {renderCategoryFooter && renderCategoryFooter(uncategorizedId, true)}
        </div>
      )}
      <Drop droppableId="droppable" type={categoryDragType}>
        {draggableOrder.map((categoryId, categoryIndex) =>
          renderCategory(categoryId, categoryIndex)
        )}
      </Drop>
    </DragAndDrop>
  )
}
